module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getReservationCalculations) ? _c('div', {
    staticClass: "bg-darker lightest mt-2 py-2 px-4"
  }, [_c('div', [(_vm.getReservationCalculations.discountValue > 0) ? _c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-baseline"
  }, [(_vm.getReservationCalculations.discountValueType == 1) ? _c('span', [_vm._v("Discount (" + _vm._s(_vm.getReservationCalculations.discountValue) + "%)")]) : _vm._e(), _vm._v(" "), (_vm.getReservationCalculations.discountValueType == 0) ? _c('span', [_vm._v("Discount (" + _vm._s(_vm.getReservationCalculations.discountValue) + "€)")]) : _vm._e(), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.totalDiscounts)) + " €")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-baseline"
  }, [_c('span', [_vm._v("Total")]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', {
    staticClass: "font-weight-600 fs-largest"
  }, [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', {
    staticClass: "font-weight-600 fs-largest"
  }, [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotal)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-baseline"
  }, [_c('span', [_c('span', [_vm._v("Deposit")]), _vm._v(" "), (_vm.getReservationCalculations.depositPaymentType == 2 && _vm.getReservationCalculations.depositType == 1) ? _c('span', [_vm._v(" (" + _vm._s(_vm.getReservationCalculations.depositValue) + "%)")]) : _vm._e(), _vm._v(" "), (_vm.getReservationCalculations.depositPaymentType == 1) ? _c('span', [_vm._v(" (Full amount)")]) : _vm._e()]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotalDepositValueRequired)) + " €")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-row justify-content-between align-items-baseline"
  }, [_vm._m(0), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
    attrs: {
      "size": "small",
      "opacity": "0.2"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations.grandTotalCommission)) + " €")])]), _vm._v(" "), _vm._l((_vm.comissionTypes), function(commissionType) {
    return (commissionType.active) ? _c('div', {
      staticClass: "d-flex flex-row justify-content-between align-items-baseline mt-1 medium"
    }, [_c('span', {
      staticClass: "d-flex align-items-center ml-2"
    }, [_vm._v("\n                    " + _vm._s(commissionType.label) + " "), (!_vm.localReservation.attachCommission['IsToOverwrite' + commissionType.type]) ? _c('span', {
      staticClass: "px-1"
    }, [_vm._v("\n                        (" + _vm._s(_vm.getReservationCalculations['entityCommissionTo' + commissionType.type + 'Value']) + _vm._s(_vm.getReservationCalculations['entityCommissionTo' + commissionType.type + 'Type'] == 1 ? '%' : '€') + ")\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.localReservation.attachCommission['IsToOverwrite' + commissionType.type]) ? _c('span', {
      staticClass: "d-flex px-1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.localReservation.attachCommission[commissionType.type + 'Value']),
        expression: "localReservation.attachCommission[commissionType.type+'Value']"
      }],
      staticClass: "glued-right px-2 py-0 text-center border-0",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.localReservation.attachCommission[commissionType.type + 'Value'])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.localReservation.attachCommission, commissionType.type + 'Value', $event.target.value)
        }, function($event) {
          return _vm.overrideCommissionChanged($event, commissionType.type)
        }]
      }
    }), _vm._v(" "), (_vm.localReservation.attachCommission[commissionType.type + 'ValueType'] == 1) ? _c('div', {
      staticClass: "glued-left w-25 py-0 px-1 pointer dark border-0",
      staticStyle: {
        "width": "auto !important"
      },
      on: {
        "click": function($event) {
          return _vm.switchCommissionType(commissionType.type)
        }
      }
    }, [_vm._v("%")]) : _vm._e(), _vm._v(" "), (_vm.localReservation.attachCommission[commissionType.type + 'ValueType'] == 0) ? _c('div', {
      staticClass: "glued-left w-25 py-0 px-1 pointer dark border-0",
      staticStyle: {
        "width": "auto !important"
      },
      on: {
        "click": function($event) {
          return _vm.switchCommissionType(commissionType.type)
        }
      }
    }, [_vm._v("€")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.localReservation.attachCommission['IsToOverwrite' + commissionType.type]) ? _c('span', {
      staticClass: "fs-small dark pointer mr-2 border-dark radius-normal px-1",
      on: {
        "click": _vm.refreshCalculations
      }
    }, [_vm._v("Apply")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "fs-small dark pointer",
      on: {
        "click": function($event) {
          return _vm.editingCommissionToogle(commissionType.type)
        }
      }
    }, [_vm._v(_vm._s(_vm.localReservation.attachCommission['IsToOverwrite' + commissionType.type] ? 'use default' : 'edit'))])]), _vm._v(" "), (_vm.getIsLoadingCalculations) ? _c('span', [_c('loader', {
      attrs: {
        "size": "small",
        "opacity": "0.2"
      }
    })], 1) : _c('span', [_vm._v(_vm._s(_vm.formatPrice(_vm.getReservationCalculations['total' + commissionType.type + 'CommissionToEntityGrossprice'])) + " €")])]) : _vm._e()
  }), _vm._v(" "), (false && _vm.loggedUserAccessList) ? _c('div', {
    staticClass: "mt-5"
  }, [_vm._v("\n                ---------------------- Debug -----------------------\n                "), _c('div', [_vm._v("User can sell components: " + _vm._s(_vm.loggedUserAccessList.isAllowedSellComponents ? 'yes' : 'no'))]), _vm._v(" "), _c('div', [_vm._v("User can sell transport: " + _vm._s(_vm.loggedUserAccessList.isAllowedSellTransports ? 'yes' : 'no'))])]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "mt-5"
  }, [_c('div', [_vm._v("Debug: Input")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Product:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.IsToOverwriteProduct),
      expression: "localReservation.attachCommission.IsToOverwriteProduct"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localReservation.attachCommission.IsToOverwriteProduct) ? _vm._i(_vm.localReservation.attachCommission.IsToOverwriteProduct, null) > -1 : (_vm.localReservation.attachCommission.IsToOverwriteProduct)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localReservation.attachCommission.IsToOverwriteProduct,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteProduct", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteProduct", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteProduct", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.productValue),
      expression: "localReservation.attachCommission.productValue"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localReservation.attachCommission.productValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localReservation.attachCommission, "productValue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.productValueType),
      expression: "localReservation.attachCommission.productValueType"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localReservation.attachCommission.productValueType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localReservation.attachCommission, "productValueType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Component:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.IsToOverwriteComponent),
      expression: "localReservation.attachCommission.IsToOverwriteComponent"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localReservation.attachCommission.IsToOverwriteComponent) ? _vm._i(_vm.localReservation.attachCommission.IsToOverwriteComponent, null) > -1 : (_vm.localReservation.attachCommission.IsToOverwriteComponent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localReservation.attachCommission.IsToOverwriteComponent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteComponent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteComponent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteComponent", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.componentValue),
      expression: "localReservation.attachCommission.componentValue"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localReservation.attachCommission.componentValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localReservation.attachCommission, "componentValue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.componentValueType),
      expression: "localReservation.attachCommission.componentValueType"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localReservation.attachCommission.componentValueType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localReservation.attachCommission, "componentValueType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Transport:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.IsToOverwriteTransport),
      expression: "localReservation.attachCommission.IsToOverwriteTransport"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localReservation.attachCommission.IsToOverwriteTransport) ? _vm._i(_vm.localReservation.attachCommission.IsToOverwriteTransport, null) > -1 : (_vm.localReservation.attachCommission.IsToOverwriteTransport)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localReservation.attachCommission.IsToOverwriteTransport,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteTransport", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteTransport", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.localReservation.attachCommission, "IsToOverwriteTransport", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.transportValue),
      expression: "localReservation.attachCommission.transportValue"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localReservation.attachCommission.transportValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localReservation.attachCommission, "transportValue", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localReservation.attachCommission.transportValueType),
      expression: "localReservation.attachCommission.transportValueType"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.localReservation.attachCommission.transportValueType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localReservation.attachCommission, "transportValueType", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('button', {
    on: {
      "click": _vm.refreshCalculations
    }
  }, [_vm._v("Calc!")])]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "mt-5"
  }, [_c('div', [_vm._v("Debug: just read")]), _vm._v(" "), _c('div', [_vm._v("Product: " + _vm._s(_vm.getReservationCalculations.entityCommissionToProductValue) + " " + _vm._s(_vm.getReservationCalculations.entityCommissionToProductType == 0 ? '€' : '%'))]), _vm._v(" "), _c('div', [_vm._v("Component: " + _vm._s(_vm.getReservationCalculations.entityCommissionToComponentValue) + " " + _vm._s(_vm.getReservationCalculations.entityCommissionToComponentType == 0 ? '€' : '%'))]), _vm._v(" "), _c('div', [_vm._v("Transport: " + _vm._s(_vm.getReservationCalculations.entityCommissionToTransportValue) + " " + _vm._s(_vm.getReservationCalculations.entityCommissionToTransportType == 0 ? '€' : '%'))])]) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "bg-color-1 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation
    },
    on: {
      "click": _vm.openPayModal
    }
  }, [_vm._v("\n                Payment\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer ml-2",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation(false)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.saveButtonLabel) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer ml-2",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation(true)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.saveAndPrintButtonLabel) + "\n        ")])]), _vm._v(" "), (_vm.localReservation.creatorAgent && false) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer mr-2",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.clickedSave ? 'Saving...' : 'Save'))]), _vm._v(" "), _c('button', {
    staticClass: "bg-color-3 radius-normal border-dark mt-2 font-weight-600 lightest text-center w-100 fs-larger py-2 pointer",
    class: {
      'disabled': _vm.noTicketsSelected || _vm.$v.$invalid
    },
    attrs: {
      "disabled": _vm.noTicketsSelected || _vm.$v.$invalid || _vm.getIsAddingReservation
    },
    on: {
      "click": function($event) {
        return _vm.saveReservation(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.clickedSaveAndPrint ? 'Saving...' : 'Save and Print'))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._v("Comissions (total)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("0 -> € | 1 -> %")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-1bca8a7e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bca8a7e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Resume/Summary/TotalAndPay.vue
// module id = 1804
// module chunks = 0